import React, { useEffect, useState } from "react";
import { api, fmt } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";

export default function Treatments() {
    const [items, setItems] = useState([]);
    useEffect(() => {
        api.get("/treatments").then((r) => setItems(r.data));
    }, []);
    return (
        <div data-testid="treatments-page">
            <h1 className="text-3xl font-bold text-slate-900">
                Tedavi Anlaşmaları
            </h1>
            <p className="text-slate-600 mt-1 mb-8">
                Tüm aktif ve tamamlanmış anlaşmalar
            </p>
            <Card>
                <CardContent className="p-0">
                    <table className="w-full">
                        <thead>
                            <tr className="border-b bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-600">
                                <th className="px-6 py-3">Hasta</th>
                                <th className="px-6 py-3">Tedavi</th>
                                <th className="px-6 py-3 text-right">
                                    Toplam
                                </th>
                                <th className="px-6 py-3 text-right">
                                    Ödenen
                                </th>
                                <th className="px-6 py-3 text-right">
                                    Kalan
                                </th>
                                <th className="px-6 py-3">Tarih</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((t) => (
                                <tr
                                    key={t.id}
                                    className="border-b hover:bg-slate-50"
                                >
                                    <td className="px-6 py-4 font-medium">
                                        <Link
                                            to={`/dashboard/patients/${t.patient_id}`}
                                            className="text-teal-700 hover:underline"
                                        >
                                            {t.patient_name}
                                        </Link>
                                    </td>
                                    <td className="px-6 py-4">{t.title}</td>
                                    <td className="px-6 py-4 text-right mono font-semibold">
                                        {fmt(t.total_amount, t.currency)}
                                    </td>
                                    <td className="px-6 py-4 text-right mono text-emerald-700">
                                        {fmt(t.paid_amount, t.currency)}
                                    </td>
                                    <td className="px-6 py-4 text-right mono text-amber-700">
                                        {fmt(t.remaining, t.currency)}
                                    </td>
                                    <td className="px-6 py-4 text-sm text-slate-500">
                                        {t.created_at?.slice(0, 10)}
                                    </td>
                                </tr>
                            ))}
                            {items.length === 0 && (
                                <tr>
                                    <td
                                        colSpan={6}
                                        className="text-center text-slate-500 py-12"
                                    >
                                        Henüz tedavi anlaşması yok. Hasta
                                        profilinden ekleyin.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </CardContent>
            </Card>
        </div>
    );
}
